var render = function render(){var _vm=this,_c=_vm._self._c;return _c('changePassword',{attrs:{"is-dark":true,"solo":true,"outlined":false,"icon-enabled":true},on:{"changepassword":_vm.onChangepassword}})
}
var staticRenderFns = []

export { render, staticRenderFns }